import Vue from 'vue'
import BaseHeading from '@/components/base/Heading'
import BaseSubheading from '@/components/base/Subheading'
import BaseText from '@/components/base/Text'

Vue.component('BaseHeading', BaseHeading)
Vue.component('BaseSubheading', BaseSubheading)
Vue.component('BaseText', BaseText)
